import React from "react";

import { IgSwitch, IgTooltip } from "@intelligems/ig-theme";
import { FormControlLabel } from "@mui/material";

interface AutoScaleSwitchProps {
  disabled: boolean;
  checked: boolean;
  onClick: () => void;
}
export const AutoScaleSwitch = ({
  disabled,
  checked,
  onClick,
}: AutoScaleSwitchProps) => {
  return (
    <IgTooltip title={"Feature not yet available"}>
      <IgSwitch
        sx={{ marginLeft: 2 }}
        size={"small"}
        disabled={true}
        checked={checked}
        color="primary"
        onClick={onClick}
        label={"Auto scale subscription each month based on order volume"}
      />
    </IgTooltip>
  );
};
